<template>
  <div style="width: 100%">
    <v-row>
      <v-col>
        <v-row>
          <h2 class="title primary--text text--darken-1 text-no-wrap mt-0 ml-2">
            PREFERÊNCIAS DE TRABALHO
          </h2>
        </v-row>
        <v-row>
          <v-col cols="12">
            <ol>
              <v-row
                v-for="perfilPreferencia in perfil.perfilPreferencias"
                :key="perfilPreferencia.preferencia.id"
              >
                <li class="grey--text text--darken-1 font-weight-bold">
                  <v-card flat>
                    <v-card-title style="padding-left: 2px;">
                      <v-row no-gutters>
                        <h5 class="grey--text text--darken-1 text-no-wrap">
                          Qual a sua preferência sobre
                          <span class="secondary--text">
                            {{ perfilPreferencia.preferencia.nome }}
                          </span>
                          ?
                        </h5>
                      </v-row>
                    </v-card-title>
                    <v-card-text style="padding-left: 0;">
                      <v-radio-group
                        v-model="perfilPreferencia.itemPreferencia.id"
                        row
                        @change="save(perfilPreferencia)"
                      >
                        <ol class="ol_itens">
                          <v-radio
                            v-for="item in mapItemOpcoes.get(perfilPreferencia.preferencia.id)"
                            :key="item.id"
                            :value="item.id"
                            return-object
                          >
                            <template v-slot:label>
                              {{ `${item.letra}. ${item.descricao}` }}
                            </template>
                          </v-radio>
                        </ol>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>
                </li>
              </v-row>
            </ol>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const perfilPreferenciaRepository = RepositoryFactory.get('perfilPreferencia');

export default {
  name: 'PreferenciasTrabalho',

  props: {
    perfil: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  data() {
    return {
      mapItemOpcoes: null,
    };
  },

  computed: {
    ...mapState({
      itensPreferencia: (state) => state.perfil.itensPreferencia,
    }),
  },

  created() {
    this.mapItemOpcoes = new Map();
    this.itensPreferencia.forEach((i) => {
      if (!this.mapItemOpcoes.has(i.preferencia.id)) {
        this.mapItemOpcoes.set(i.preferencia.id, []);
      }
      this.mapItemOpcoes.get(i.preferencia.id).push(i);
    });

    this.perfil.perfilPreferencias.forEach((p) => {
      if (p.itemPreferencia == null) {
        p.itemPreferencia = { id: null };
      }
    });
  },

  methods: {
    save(item) {
      perfilPreferenciaRepository.save(item)
        .then((res) => {
          const perfilPreferencia = res.data;
          const index = this.perfil.perfilPreferencias.findIndex(
            (p) => p.key.perfilId === perfilPreferencia.key.perfilId
              && p.key.preferenciaId === perfilPreferencia.key.preferenciaId,
          );
          this.perfil.perfilPreferencias.splice(index, 1, perfilPreferencia);
          this.$store.dispatch('app/success', { response: res, message: 'Preferência salva com sucesso!' });
        });
    },
  },
};
</script>

<style scoped>
ol.ol_itens {
  display: flex;
  padding-left: 0;
}
</style>
